import { SurveyItem, ItemTypes, SurveyItemQuery } from "@/models/SurveyItem";
import { Dictionary } from "vue-router/types/router";
import { SurveyText } from "./SurveyText";

export interface JsonObject {
  surveyId: string;
  hashCode: string;
  createdDateTime: string;
  updatedDateTime: string;
  title: object;
  details: object;
  langs: object;
  qrPrefix: string;
  qrAnswerDate: boolean;
  surveyItems: object;
}

export class SurveyForm {
  constructor(
    public surveyId: string,
    public hashCode: string,
    public createdDateTime: string,
    public updatedDateTime: string,
    public title: SurveyText[],
    public details: SurveyText[],
    public langs: SurveyText[],
    public qrPrefix: string,
    public qrAnswerDate: boolean,
    public surveyItems: SurveyItem[]
  ) {}

  static objectToMap(obj: object): Map<string, string> {
    return new Map<string, string>(Object.entries(obj));
  }

  static getInstanceForJson(jsonObj: JsonObject): SurveyForm {
    if (jsonObj.surveyItems instanceof Array) {
      jsonObj.surveyItems.map(
        (value: SurveyItem[], index: number, item: SurveyItem[]) => {
          if (item[index].units == null) {
            item[index].units = [];
          }
          if (item[index].unitsRules == null) {
            item[index].unitsRules = false;
          }
        }
      );
    }

    return new SurveyForm(
      jsonObj.surveyId,
      jsonObj.hashCode,
      jsonObj.createdDateTime,
      jsonObj.updatedDateTime,
      jsonObj.title as SurveyText[],
      jsonObj.details as SurveyText[],
      jsonObj.langs as SurveyText[],
      jsonObj.qrPrefix,
      jsonObj.qrAnswerDate,
      jsonObj.surveyItems as SurveyItem[]
    );
  }

  static async getInstanceForJsonUrl(jsonUrl: string): Promise<SurveyForm> {
    const response = await fetch(jsonUrl);
    return await response.json();
  }

  static jsonObjectToSurveyItemQuerys(json: object) {
    return Object.values(json).map(this.jsonObjectToSurveyItemQuery);
  }

  static jsonObjectToSurveyItemQuery(json: (string | string[][])[]) {
    return new SurveyItemQuery(
      json[0] as ItemTypes,
      json[1] as string,
      json[2] as string[][],
      json[3] as string,
      json[4] as string,
      json[5] as string[][],
      json[6] as string[][],
      json[7] as string
    );
  }

  static getInstance(query: Dictionary<string | (string | null)[]>) {
    return new SurveyForm(
      query.surveyId as string,
      query.hashCode as string,
      query.createdDateTime as string,
      query.updatedDateTime as string,
      SurveyText.getInstances(JSON.parse(query.title as string)),
      SurveyText.getInstances(JSON.parse(query.details as string)),
      SurveyText.getInstances(JSON.parse(query.langs as string)),
      query.qrPrefix as string,
      query.qrAnswerDate == "1",
      SurveyItem.getInstances(
        this.jsonObjectToSurveyItemQuerys(JSON.parse(query.cols as string))
      )
    );
  }
}
